import React from "react";
import { Badge } from "react-bootstrap";

const CustomSizePerPage = ({ getData, currentSizePerPage }) => {
  return (
    <div className="bootstrap-badge">
      <Badge
        as="a"
        bg=""
        className={`${
          currentSizePerPage == 10 ? "badge-primary" : "badge-outline-primary"
        }`}
        style={{ borderRadius: "0.25rem 0rem 0rem 0.25rem" }}
        onClick={() => {
          getData(1, 10);
        }}
      >
        10
      </Badge>
      <Badge
        as="a"
        bg=""
        className={`${
          currentSizePerPage == 25 ? "badge-primary" : "badge-outline-primary"
        }`}
        style={{ borderRadius: "0rem", borderLeft: "0" }}
        onClick={() => {
          getData(1, 25);
        }}
      >
        25
      </Badge>
      <Badge
        as="a"
        bg=""
        className={`${
          currentSizePerPage == 50 ? "badge-primary" : "badge-outline-primary"
        }`}
        style={{ borderRadius: "0rem", borderLeft: "0" }}
        onClick={() => {
          getData(1, 50);
        }}
      >
        50
      </Badge>
      <Badge
        as="a"
        bg=""
        className={`${
          currentSizePerPage == 100 ? "badge-primary" : "badge-outline-primary"
        }`}
        style={{
          borderRadius: "0rem 0.25rem 0.25rem 0rem",
          borderLeft: "0",
        }}
        onClick={() => {
          getData(1, 100);
        }}
      >
        100
      </Badge>
    </div>
  );
};

export default CustomSizePerPage;
